export default __webpack_public_path__ + "fd67cfeceebc2bfe3b65b7d3a8ce23ba.png";